import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd042aService,
  Sgkd042aRequest,
  Sgkd042aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd010dSgkd042aService {

  private _rsesult$ = new Subject<Sgkd042aResponse>();

  constructor(
    private sgkd042aService: Sgkd042aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 依頼返却金融機関名取得API呼び出し
   * @param reqretFinancialinstitutioncode 依頼返却金融機関コード
   * @memberof UsedSgkd010dSgkd042aService
   */
  select(reqretFinancialinstitutioncode: string): Observable<Sgkd042aResponse> {

    // リクエスト生成
    let request: Sgkd042aRequest = {
      requestDto: {
        reqretFinancialinstitutioncode: reqretFinancialinstitutioncode
      }
    };

    return this.sgkd042aService.doSGKD042APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD042A');
          return throwError(err.message);
        }
      )
    );
  }
}
